/**
 * Created by renatolovizotto on 04/07/17.
 */
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import PropTypes from 'prop-types';
import '../assets/stylesheets/Header.scss';


import btnSair from './../assets/images/btn_sair.svg';
import logoConquerBusiness from './../assets/images/logoConquerBusiness.svg';

@inject('Navigator', 'AuthStore', 'ConfigStore', 'ProductStore')
@observer
export default class Header extends Component {

    firedEvent = false;

    static propTypes = {
        onSearch: PropTypes.func,
        onLogout: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            searchedTerm: '',
            dropdownOpen: false,
            productDropdownOpen: false,
        };
        this.headerRef = null;
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick = (event) => {
        if (!this.headerRef || this.headerRef.contains(event.target)) {
            return;
        }

        if (this.state.dropdownOpen || this.state.productDropdownOpen) {
            this.setState({ dropdownOpen: false, productDropdownOpen: false });
        }
    };

    dispatchLogoff() {
        this.props.onLogout();
    }

    toggleDropdown = () => {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    toggleProductDropdown = () => {
        this.setState({ productDropdownOpen: !this.state.productDropdownOpen });
    }

    handleSelectProduct = (productId) => {
        this.props.ProductStore.setProduct(productId);
        this.setState({ productDropdownOpen: false });
        this.props.ConfigStore.animationType = 'left';
        this.props.Navigator.push('/');
    }

    renderProductMenuItem(product) {
        const { ProductStore } = this.props;
        const isActive = ProductStore.selectedProduct === product.id;

        return (
            <li
                key={product.id}
                className={isActive ? 'product-option-active' : ''}
                onClick={() => this.handleSelectProduct(product.id)}
            >
                {product.name}
                {isActive ? ' ✓' : ''}
            </li>
        );
    }

    getProductMenuLabel() {
        const { ProductStore } = this.props;
        const active = ProductStore.currentProduct;

        if (active) {
            return `${active.name} ▾`;
        }

        return 'PRODUTO ▾';
    }

    handleSearch(e) {
        const value = e.target.value;

        if ( value.length >= 1 ) {
            this.setState({
                searchedTerm: e.target.value
            });

            if (this.props.onSearch) {
                this.props.onSearch({searchedTerm: value});
            }
        }
    }

    handleKeyPress = (event) => {
        if(event.key == "Enter"){
            document.getElementsByTagName('input')[0].blur();
        }
    }

    handleNavigate(uri) {
        this.props.ConfigStore.animationType = 'left';
        this.props.Navigator.push(`${uri}`)
    }

    renderMenu() {
        return (
            <nav className="menu">
                <ul>
                    <li className={`dropdown${this.state.dropdownOpen ? ' is-open' : ''}`}>
                        <span onClick={this.toggleDropdown}>Registrar presença ▾</span>
                        {this.state.dropdownOpen &&
                            <ul className="dropdown-menu">
                                <li onClick={this.handleNavigate.bind(this, '/class-report')}>Registrar presença</li>
                                <li onClick={this.handleNavigate.bind(this, '/qrcode-scan')}>Ler QRCode aluno</li>
                            </ul>
                        }
                    </li>

                    <li onClick={this.handleNavigate.bind(this, '/eboard')}>Materiais</li>
                    <li onClick={this.handleNavigate.bind(this, '/rocket')}>Rocket</li>
                    <li onClick={this.handleNavigate.bind(this, '/library')}>Biblioteca</li>
                    <li onClick={this.handleNavigate.bind(this, '/qrcode-scan')}>Ler QRCode</li>
                </ul>
            </nav>
        );
    }

    renderProductSelector() {
        const { ProductStore } = this.props;
        const productLabel = this.getProductMenuLabel();

        if (!ProductStore.isProductSelectorVisible) {
            return null;
        }

        return (
            <div className={`dropdown product-dropdown${this.state.productDropdownOpen ? ' is-open' : ''}`}>
                <span
                    className="product-menu-trigger"
                    onClick={this.toggleProductDropdown}
                    title={productLabel}
                >
                    {productLabel}
                </span>
                {this.state.productDropdownOpen &&
                    <ul className="dropdown-menu">
                        {ProductStore.products.map((product) =>
                            this.renderProductMenuItem(product)
                        )}
                    </ul>
                }
            </div>
        );
    }

    render() {

        if (!this.props.AuthStore.checkAuth)
            return null;

        return (
            <div className="Header" ref={(el) => { this.headerRef = el; }}>
                <div className="logo-small" onClick={this.handleNavigate.bind(this, '/')}>
                    <img role="presentation" src={logoConquerBusiness} alt="Conquer Business School"/>
                </div>
                {this.renderMenu()}
                <div className="header-end">
                    {this.renderProductSelector()}
                    <div className="logoff">
                        <img
                            role="presentation"
                            src={btnSair}
                            alt="Sair"
                            onClick={this.dispatchLogoff.bind(this)}
                            width={30}
                            height={30}
                        />
                    </div>
                </div>
            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./src/containers/Header.js